export default "__VITE_ASSET__DN6Ynf2o__"